export default __webpack_public_path__ + "static/media/iread2.65936596.jpeg";